import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { api } from '../lib/api'
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card"
import { Button } from "../components/ui/button"
import { toast } from 'sonner'

export default function AdminDashboard() {
  const [stats, setStats] = useState({
    newLeads: 0,
    approvedLeads: 0,
    blockedLeads: 0,
    totalSalesReps: 0
  })
  const navigate = useNavigate()

  useEffect(() => {
    fetchStats()
  }, [])

  async function fetchStats() {
    try {
      // Leads Statistiken
      const leads = await api.getLeads()
      const stats = leads.reduce((acc, lead) => {
        acc[lead.status] = (acc[lead.status] || 0) + 1
        return acc
      }, {})

      // Anzahl der Vertriebler
      const users = await api.getUsers()
      const salesReps = users.filter(user => user.role === 'sales')

      setStats({
        newLeads: stats.new || 0,
        approvedLeads: stats.approved || 0,
        blockedLeads: stats.blocked || 0,
        totalSalesReps: salesReps.length
      })
    } catch (error) {
      console.error('Fehler beim Laden der Statistiken:', error)
      toast.error('Statistiken konnten nicht geladen werden')
    }
  }

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold">Admin Dashboard</h1>
        <div className="space-x-2">
          <Button onClick={() => navigate('/admin/users')}>
            Benutzerverwaltung
          </Button>
          <Button onClick={() => navigate('/leads')}>
            Leads anzeigen
          </Button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Card>
          <CardHeader>
            <CardTitle>Neue Leads</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-3xl font-bold">{stats.newLeads}</p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Freigegebene Leads</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-3xl font-bold">{stats.approvedLeads}</p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Blockierte Leads</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-3xl font-bold">{stats.blockedLeads}</p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Aktive Vertriebler</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-3xl font-bold">{stats.totalSalesReps}</p>
          </CardContent>
        </Card>
      </div>
    </div>
  )
} 